import axios from '../lib/axios'
import AuthenticationService from '../services/AuthenticationService'
import Store from '../store/Store'
const url = process.env.ZLICK_V2

export default {
  start: ({ providerId, userPhone, language }) => {
    if (!AuthenticationService.isInRole(['admin', 'telemarketing'])) throw new Error('Permission denied. Cannot start smsauth')
    return axios({
      method: 'POST',
      url: url + '/smsauth',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
        'zlick-group': Store.getters.getActiveCognitoGroup
      },
      data: {
        phone: userPhone
      }
    })
  },
  complete: ({ providerId, inputBody, challengeId }) => {
    if (!AuthenticationService.isInRole(['admin', 'telemarketing'])) throw new Error('Permission denied. Cannot start smsauth')
    return axios({
      method: 'PUT',
      url: url + '/smsauth',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
        'zlick-group': Store.getters.getActiveCognitoGroup
      },
      data: {
        challengeId,
        pinCode: inputBody
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/smsAuthService.js